module.exports = __webpack_public_path__ + "img/team-1-8.071e7af3.jpeg";